// Display label for a DTrackIt ref-code option, normally "Description (CODE)".
// Some ref-data rows carry the same text in both code and description (e.g. the
// Product Unit Metrics like "units", or standards seeded as "SFA"/"GOTS") — for
// those, repeating the text in brackets reads as a duplicate ("units (units)"),
// so the text is shown only once (86ajey0yf, 86ajey1u1).
export const formatRefCodeLabel = (description?: any, code?: any): string => {
  const desc = String(description ?? "").trim();
  const codeText = String(code ?? "").trim();
  if (!desc) return codeText;
  if (!codeText || desc.toLowerCase() === codeText.toLowerCase()) return desc;
  return `${desc} (${codeText})`;
};
